// extracted by mini-css-extract-plugin
export default {"root":"PlasmicMilestoneFooter_root__c3R0G","submitButton":"PlasmicMilestoneFooter_submitButton__UQ0LE","text":"PlasmicMilestoneFooter_text__u8J+o"};